import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';

export const QUERY = gql`
  query GetLeaderReportPdf($quizId: ID!) {
    getLeaderReportPdf(quizId: $quizId) {
      reportUrl
    }
  }
`;

export type Variables = {
  quizId: string;
};

export type Response = {
  readonly getLeaderReportPdf: {
    reportUrl: string;
  };
};

export const useGetLeaderReportPdfQuery = (
  options?: QueryHookOptions<Response, Variables>,
) => useLazyQuery<Response, Variables>(QUERY, options);
